import { jsx as _jsx } from "react/jsx-runtime";
import { Orientation } from '../../../Constants/System';
import styled from 'styled-components';
import EvenGrid from '../../../Components/Content/EvenGrid';
export default function ButtonGroup(props) {
    const { children, className, orientation = Orientation.horizontal } = props;
    return (_jsx(StyledButtonGroup, { orientation: orientation, className: className, children: children }));
}
const StyledButtonGroup = styled(EvenGrid) `
	margin: ${(props) => props.theme.spacing.xl} 0;
	gap: ${(props) => props.theme.spacing.xs};
	width: 100%;
`;
//# sourceMappingURL=ButtonGroup.js.map